import * as types from '../types'

// get user from localStorage
const initialState = {
    loading: false,
    admins: [],
    admin: {},
    error: null
}

export const adminReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.CREATE_ADMIN_USER:
            return {
                ...state,
                admins: [...state.admins, action.payload],
                loading: false,
                error: null
            }
        case types.GET_ADMIN_USERS:
            return {
                ...state,
                admins: action.payload,
                loading: false,
                error: null
            }

        case types.SET_LOADING:
            return {
                ...state,
                loading: true,
                error:null
            }
            case types.RESET_LOADING:
                return {
                    ...state,
                    loading: false,
                    error:null
                }
        case types.RESET:
            return {
                ...state,
                loading: false,
                error:null
            }
        case types.SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            }
        default:
            return state
    }
}